<template>
  <Breadcrumb
    style="padding-top:20px;padding-bottom:20px;"
    v-if="list && list.length"
  >
    <BreadcrumbItem
      v-for="item in list"
      :key="item.fullPath"
      class="BreadcrumbItem"
      :class="{ 'is-current': isCurrent(item) }"
      :to="isCurrent(item) ? undefined : item.fullPath"
      ><span @click="watchBread(item)">{{
        item.meta && item.meta.title
      }}</span></BreadcrumbItem
    >
  </Breadcrumb>
</template>
<script>
import sessionStorage from '@/utils/storage/sessionStorage';

// 面包屑轨迹的存储 key（由路由守卫 main.js 的 breadFn 维护）
const BREAD_KEY = 'bread';

export default {
  props: {
    // 当前页那一格怎么处理（二选一）：
    //   'grey' 置灰显示：留着这一格但不做成链接，点了没反应（默认）
    //   'hide' 不显示：整格去掉
    // 用法：<Bread current-mode="hide"></Bread>
    currentMode: {
      type: String,
      default: 'grey',
      validator: value => ['grey', 'hide'].includes(value)
    },
    // 兼容旧用法：hideLast=true 等价于 current-mode="hide"
    hideLast: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bread: []
    };
  },
  computed: {
    // 最终生效的模式（旧 prop 优先）
    mode() {
      return this.hideLast ? 'hide' : this.currentMode;
    },
    list() {
      const bread = this.bread || [];
      // 不显示模式：按当前路由精确剔除那一格
      // （比 slice(0, -1) 稳：当前页万一不在轨迹里时，不会误删最后一格）
      if (this.mode === 'hide') {
        return bread.filter(item => !this.isCurrent(item));
      }
      return bread;
    }
  },
  methods: {
    // 是否是当前页：是则渲染成纯文本（点自己不会有任何变化，vue-router 会判重复导航）
    isCurrent(item) {
      return !!item && item.fullPath === this.$route.fullPath;
    },
    watchBread(item) {
      // 点的是当前页：什么都不做。
      // 原来这里会先把轨迹截断，于是出现"页面没变、只是面包屑变了"的错觉
      if (!item || this.isCurrent(item)) return;
      const bread = sessionStorage.get(BREAD_KEY);
      if (!Array.isArray(bread) || !bread.length) return;
      // 按 fullPath 匹配，不再依赖对象引用相等
      // （sessionStorage 里可能拿到重新解析出来的数组，引用比对会漏掉）
      const index = bread.findIndex(data => data.fullPath === item.fullPath);
      if (index === -1) return;
      // 点中间某一格：把它后面的项先删掉，展示立刻收敛；
      // 路由守卫里有同样的截断（保证轨迹最后一项＝当前页），这里只是让响应更快
      if (index < bread.length - 1) {
        bread.splice(index + 1);
        sessionStorage.set(BREAD_KEY, bread);
        this.init();
      }
    },
    init() {
      const bread = sessionStorage.get(BREAD_KEY);
      this.bread = Array.isArray(bread) ? bread : [];
    }
  },
  mounted() {
    this.init();
  },
  watch: {
    $route() {
      this.init();
    }
  }
};
</script>

<style lang="scss" scoped>
// 当前页那一格（默认 current-mode="grey"）：置灰、不可点
// 组件库里给「最后一个 span」加了加粗深色（.ivu-breadcrumb > span:last-child），
// 这里的选择器权重更高，能把当前页覆盖成灰色
.BreadcrumbItem.is-current {
  /deep/ .ivu-breadcrumb-item-link {
    color: #c5c8ce;
    font-weight: 400;
    cursor: default;
  }
}
</style>
